import createIcon from '../../createIcon';

/**
 * @component @name ConfirmationNumber
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTBWNkMyMiA0Ljg5IDIxLjEgNCAyMCA0SDRDMi45IDQgMi4wMSA0Ljg5IDIuMDEgNlYxMEMzLjExIDEwIDQgMTAuOSA0IDEyQzQgMTMuMSAzLjExIDE0IDIgMTRWMThDMiAxOS4xIDIuOSAyMCA0IDIwSDIwQzIxLjEgMjAgMjIgMTkuMSAyMiAxOFYxNEMyMC45IDE0IDIwIDEzLjEgMjAgMTJDMjAgMTAuOSAyMC45IDEwIDIyIDEwWk0xMyAxNy41SDExVjE1LjVIMTNWMTcuNVpNMTMgMTNIMTFWMTFIMTNWMTNaTTEzIDguNUgxMVY2LjVIMTNWOC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ConfirmationNumber = createIcon('ConfirmationNumber', [
  [
    'path',
    {
      d: 'M22 10V6C22 4.89 21.1 4 20 4H4C2.9 4 2.01 4.89 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12C20 10.9 20.9 10 22 10ZM13 17.5H11V15.5H13V17.5ZM13 13H11V11H13V13ZM13 8.5H11V6.5H13V8.5Z',
      key: '1e9qg5',
    },
  ],
]);

export default ConfirmationNumber;
